<bzg-modal-header>
  <span class="bzg-modal__header__title">{{ 'ACCOUNT_INFORMATION.EMAIL_SENT_TITLE' | translate}}</span>
</bzg-modal-header>
<bzg-modal-content>
  <p class="email-sent-dialog__text">
      {{ 'ACCOUNT_INFORMATION.EMAIL_SENT_DESCRIPTION' | translate}}
  </p>
</bzg-modal-content>
<bzg-modal-footer class="email-sent-dialog__footer">
  <bzg-button-primary (click)="close()">{{ 'GLOBAL.CLOSE' | translate}}</bzg-button-primary>
</bzg-modal-footer>
